// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-form-item.is-error .social-handle-input,.el-form-item.is-error .social-handle-input:has(input:focus){border-color:#e5285d}.el-form-item.is-error .social-handle-input .el-input-group__append,.el-form-item.is-error .social-handle-input:has(input:focus) .el-input-group__append{visibility:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
